import { Box, Button, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { ReactComponent as Warning } from 'assets/icons/warning.svg';

type ResetErrorProps = {
	email: string;
	setIsEmailWrong: (arg0: boolean) => void;
};

export const ResetError: FC<ResetErrorProps> = ({ email, setIsEmailWrong }) => {
	const { t: modalsTranslate } = useTranslation(NamespacesList['modals']);

	return (
		<Box
			className="rtl-able"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				alignSelf: 'center',
				width: { xs: '100%', sm: '438px' },
				margin: '48px 0',
			}}
		>
			<Warning />

			<Typography
				variant="h3"
				sx={{ fontSize: '24px', fontWeight: '700', marginTop: { xs: '16px', sm: '32px' } }}
			>
				{modalsTranslate('resetPasswordErrorModal.title')}
			</Typography>

			<Typography sx={{ color: '#9FA6B3', marginTop: '8px', textAlign: 'center' }}>
				{modalsTranslate('resetPasswordErrorModal.description')}
			</Typography>
			<Typography sx={{ color: '#58647B', fontWeight: '700', textAlign: 'center' }}>
				{email}
			</Typography>

			<Button
				sx={{
					height: '44px',
					width: { xs: '100%', sm: '438px' },
					borderRadius: '8px',
					textTransform: 'none',
					fontSize: '16px',
					fontWeight: '700',
					marginTop: '24px',
				}}
				variant="contained"
				color="primary"
				onClick={() => setIsEmailWrong(false)}
			>
				{modalsTranslate('resetPasswordErrorModal.confirm')}
			</Button>
		</Box>
	);
};
